import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";

export default function LandlordNotifications() {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    // Placeholder: fetch notifications from API
  }, []);

  return (
    <div className="space-y-6" data-testid="landlord-notifications">
      <div>
        <h1 className="text-3xl font-bold font-display">Notifications</h1>
        <p className="text-sm text-gray-500 mt-1">Stay updated on important events.</p>
      </div>

      {/* Notifications List */}
      <div className="card-base p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold">All Notifications</h3>
          {notifications.length > 0 && (
            <button className="text-xs text-[#F97316] hover:underline">Mark all as read</button>
          )}
        </div>

        <div className="text-center py-12 text-gray-500">
          <Bell className="h-8 w-8 text-gray-200 mx-auto mb-2" />
          <p>No notifications yet.</p>
          <p className="text-sm mt-1">You'll receive updates about your deposits here.</p>
        </div>
      </div>
    </div>
  );
}
